import { render } from "./KeepWatchingCard.vue?vue&type=template&id=525fc856&scoped=true"
import script from "./KeepWatchingCard.vue?vue&type=script&lang=js"
export * from "./KeepWatchingCard.vue?vue&type=script&lang=js"

import "./KeepWatchingCard.vue?vue&type=style&index=0&id=525fc856&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525fc856"]])

export default __exports__